module.exports = __webpack_public_path__ + "static/images-6567719a81e82a37995959cd78f062c7.png";